import {ChangeEvent} from "react"

export type PptCheckboxProps = {
  name?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => unknown
  labelText?: string
  isChecked?: boolean
  className?: string
}

export default function PptCheckbox({
  name = "",
  onChange,
  labelText = "checkbox",
  isChecked = false,
  className = "",
}: PptCheckboxProps) {
  return (
    <div className={`ppt-checkbox box-shadow-subtle ${className}`}>
      <input
        className="ppt-checkbox-input"
        type="checkbox"
        id={name}
        name={name}
        onChange={onChange}
        checked={isChecked}
      ></input>
      <label htmlFor={name} className="ppt-checkbox-label">
        {labelText}
      </label>
    </div>
  )
}